// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2YBEc","title":"FrontImage_title__3GD1K"};